import { render } from "./LogisticsTrack.vue?vue&type=template&id=01190127&scoped=true&ts=true"
import script from "./LogisticsTrack.vue?vue&type=script&lang=ts"
export * from "./LogisticsTrack.vue?vue&type=script&lang=ts"

import "./LogisticsTrack.vue?vue&type=style&index=0&id=01190127&scoped=true&lang=css"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01190127"]])

export default __exports__